import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Globals } from '../globals';
import { User } from '../service/modal/user';
import { Router } from '@angular/router';
import { LoginService } from '../service/apiservice/login.service';
import { UtilFunctions } from '../util-functions';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NgxSpinnerService } from "ngx-spinner";
import { HealthHistory } from '../service/modal/healthhistory';
import { HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';


// import  from 'print-js';
declare var $;
declare var printJS;
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  other = "";

  avatarImgSrc: string = 'assets/images/avatar.png';
  userInfo: User;
  healthCard;
  healthhistory = "";
  selectedMailList = [];


  //combobox with checkbox 

  selectedItems = [];
  dropdownSettings = {};
  healthHistoryList: HealthHistory[] = new Array();
  base64Data:string;
  @ViewChild('printForMobile') printForMobile:ElementRef;
 
  hcBackSideForm: FormGroup;
  isHealthCardBackSideForm = false;
  healthCardBackSidePreviewObj: any;
  constructor(private formBuilder: FormBuilder,private spinner: NgxSpinnerService, private spinnerService: Ng4LoadingSpinnerService, private global: Globals, private router: Router, private _loginService: LoginService) { }


  ngOnInit() {
    debugger;
    localStorage.setItem("Active Route",this.router.url);

    this.getUserInfoById();
   
    this.healthHistoryList = [
      { id: 0, itemName: "Acidity" },
      { id: 1, itemName: "Arthritis" },
	    { id:2, itemName: "Asthma" },
	    { id: 3, itemName: "Blood pressure" },
	    { id: 4, itemName: "Cancer / Cancer History" },
	    { id: 5, itemName: "Cholesterol" },
		  { id: 6, itemName: "Diabetes" },
		  { id: 7, itemName: "Epilapsy" },
	    { id: 8, itemName: "Gastric Ulcer" },
		  { id: 9, itemName: "Heart Disease" },
		  { id:10, itemName: "HIV" },
		  { id: 11, itemName: "Hypertension" },
		  { id: 12, itemName: "Other" },
      { id: 13, itemName: "Pregnancy / Breastfeeding" },
      { id: 14, itemName: "Thyroid" }
    ];
   
    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Health History",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes:"myclass custom-class"
    };
    $(document).ready(function () {
      $('#othertextfield').hide();
    });
    // this.userInfo = this.global.loggedUser.user;

  
    $("#previewHealthCardModal").modal("hide");
  
  }

getUserInfoById(){
  this._loginService.getUserById(this.global.loggedUser.user.user_reg_id).subscribe(response=>{
    this.userInfo =response;
    this.loadHealthHistory();
  },err=>{});
 
}

  updateProfile() {
    this.router.navigate(['dashboard/updateprofile/' + this.userInfo.user_reg_id]);
  }
  downloadHealthCard() {
    this.healthhistory = "";
    this.spinner.show();
    // for (var i = 0; i < this.selectedMailList.length; i++) {
    //   this.healthhistory = this.healthhistory + this.selectedMailList[i] + ",";
    //   if (this.selectedMailList[i] == 'Other') {
    //     this.userInfo.other = this.other;
    //   }
    // }
    // this.userInfo.healthHistory = this.healthhistory;
    for (var i = 0; i < this.selectedItems.length; i++) {
      this.healthhistory = this.healthhistory + this.selectedItems[i].itemName + ",";
      if (this.selectedItems[i].itemName == 'Other') {
        this.userInfo.other = this.other;
      }

    }

    this.userInfo.healthHistory = this.healthhistory;
    this._loginService.createHealthCard(this.userInfo).subscribe((response) => {
      this.spinner.hide();
      this.healthCard = response.healthcardpath;
      this.healthhistory = "";
      // this.global.loggedUser.user = new User;
      // this.userInfo = this.global.loggedUser.user;
      // Object.assign(this.global.loggedUser.user, response);
      // UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
      window.open(this.healthCard, '_self');
      this.clearData();
      // this.getUserInfoById();
    }, err => {  this.spinner.hide();});
  }
  previewHealthCard() {
    this.healthCard = "";
    this.spinner.show();
    // for (var i = 0; i < this.selectedMailList.length; i++) {
    //   this.healthhistory = this.healthhistory + this.selectedMailList[i] + ",";
    //   if (this.selectedMailList[i] == 'Other') {
    //     this.userInfo.other = this.other;
    //   }
    // }
    // this.userInfo. healthHistory = this.healthhistory;

    for (var i = 0; i < this.selectedItems.length; i++) {

      this.healthhistory = this.healthhistory + this.selectedItems[i].itemName + ",";
      if (this.selectedItems[i].itemName == 'Other') {
        this.userInfo.other = this.other;
      }
    }
    // if (window.innerWidth <= 600) {
    //   this.base64Data="";
    //   this._loginService.createHealthCardMobileView(this.userInfo).subscribe((response) => {
    //   this.spinner.hide();
    //   this.healthCard = response.healthcardpath;
    //   this.healthhistory = "";
    //   this.base64Data=response.base64String
    //   console.log("healthcard ::::" + this.healthCard);
    //   if (this.healthCard != 'undefined') {
    //     $("#previewHealthCardModal").modal("show");
    //   }
    //   this.getUserInfoById();
    // }, err => { 
    //   this.spinner.hide();
    // });
    // }else{
    this.userInfo.healthHistory = this.healthhistory;

    this._loginService.createHealthCard(this.userInfo).subscribe((response) => {
      this.spinner.hide();
      // this.healthCard = response.healthcardpath;
      this.healthhistory = "";
      console.log("healthcard ::::" + this.healthCard);

      this._loginService.getUserById(this.userInfo.user_reg_id).subscribe((response) => {
        debugger
        this.spinner.hide();
        this.loadHealtCardBakSideForm(response, "PrintPage");
  
        $("#previewORPrintHealthCardModal").modal("show");
       
      }, err => {
        this.spinner.hide();
      });




      // if (this.healthCard != 'undefined') {
      //   $("#previewHealthCardModal").modal("show");
      // }
      
    }, err => { this.spinner.hide(); });
  
  }
  shareHealthCard() {
    this.healthCard = "";
    this.healthhistory = "";
    this.spinner.show();
    // for (var i = 0; i < this.selectedMailList.length; i++) {
    //   this.healthhistory = this.healthhistory + this.selectedMailList[i] + ",";
    //   if (this.selectedMailList[i] == 'Other') {
    //     this.userInfo.other = this.other;
    //   }
    // }
    // this.userInfo.healthHistory = this.healthhistory;
    for (var i = 0; i < this.selectedItems.length; i++) {

      this.healthhistory = this.healthhistory + this.selectedItems[i].itemName + ",";
      if (this.selectedItems[i].itemName == 'Other') {
        this.userInfo.other = this.other;
      }
    }

    this.userInfo.healthHistory = this.healthhistory;




    this._loginService.createHealthCard(this.userInfo).subscribe((response) => {
      this.spinner.hide();
      this.healthCard = response.healthcardpath;
      this.healthhistory = "";
      // this.global.loggedUser.user = new User;
      // this.userInfo = this.global.loggedUser.user;
      // Object.assign(this.global.loggedUser.user, response);
      // UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
      // this.router.navigate(['dashboard/sharehealthcard']);
      this.global.sharehealthCard = this.healthCard;
      $("#shareHealthCardModal").modal("show");
      // this.getUserInfoById();

    }, err => { 
      this.spinner.hide();
    });
  }
  clearData() {
    this.healthhistory = "";
    this.healthCard = "";
    this.selectedMailList = [];
    // this.selectedCheckbox(this.userInfo.healthHistory);
  }
  OtherHealthHistory(other) {
    this.other = other;
    console.log(this.other);
  }
  checkboxChanged(event) {
    // console.log(event.target.value);
    debugger;
    if (event.target.checked) {
      if (event.target.value === 'Other') {
        $('#othertextfield').show();
        if (this.selectedMailList.length == 13) {
           info_noti("you are Entered only 60 Character in other");
        }
      }
      this.selectedMailList.push(event.target.value);
    }
    else {
      if (event.target.value === 'Other') {
        $('#othertextfield').hide();
        $('#otherhealthhistory').val("");
      }
      this.selectedMailList.splice(this.selectedMailList.indexOf(event.target.value), 1);
    }

  }

  selectedCheckbox(healthhistory) {
    if (healthhistory != null) {
      var healthhistoryarr = healthhistory.split(",");
      for (var i = 0; i < healthhistoryarr.length; i++) {
        // console.log("'#"+this.selectedMailList[i]+"'");
        if (healthhistoryarr[i] === "Heart Disease") {
          var checkboxid = "#HeartDisease";
          this.selectedMailList.push(healthhistoryarr[i]);
        } else if (healthhistoryarr[i] === "Pregnancy / Breastfeeding") {
          var checkboxid = "#Pregnancy";
          this.selectedMailList.push(healthhistoryarr[i]);
        } else if (healthhistoryarr[i] === "Cancer / Cancer History") {
          var checkboxid = "#Cancer";
          this.selectedMailList.push(healthhistoryarr[i]);
        } else if (healthhistoryarr[i] === "Gastric Ulcer") {
          var checkboxid = "#GastricUlcer";
          this.selectedMailList.push(healthhistoryarr[i]);
        } else if (healthhistoryarr[i] === "Blood pressure") {
          var checkboxid = "#Bloodpressure";
          this.selectedMailList.push(healthhistoryarr[i]);
        } else if (healthhistoryarr[i] === "Other") {
          var checkboxid = "#Other";
          $('#otherhealthhistory').val(this.userInfo.other);
          $('#othertextfield').show();
          this.selectedMailList.push(healthhistoryarr[i]);
          this.other = this.userInfo.other;
        } else if (healthhistoryarr[i] === "") {

        } else {
          var checkboxid = "#" + healthhistoryarr[i] + "";
          this.selectedMailList.push(healthhistoryarr[i]);
        }
        $(checkboxid).prop("checked", true);
      }
    }

  }

  printHelathCard() {
    printJS(this.healthCard);
    // printJS("'"+this.healthCard+"'");
    // printJS({printable:"'"+this.healthCard+"'", type:'pdf', showModal:true})

    // window.open(this.healthCard, '_self');
    // var DocumentContainer = document.getElementById("print-section");
    // var WindowObject = window.open('', 'PrintWindow', 'width=1310,height=650,top=0,left=0,toolbars=no,scrollbars=yes,status=no,resizable=yes');
    // WindowObject.print();

    // WindowObject.document.writeln(DocumentContainer.innerHTML);

    // WindowObject.document.close();
    // WindowObject.focus();
    // WindowObject.print();
    // WindowObject.close();

    // if(WindowObject.close)
    // {
    // window.location.reload();
    // }

    // window.location.assign(this.healthCard);
    // var objFra = document.getElementById('myFrame');
    // objFra.contentWindow.focus();
    // objFra.contentWindow.print();

  }
  loadHealthHistory() {
    if (this.userInfo!= undefined ) {
      if(this.userInfo.healthHistory!=null){
        this.selectedItems = [];
      var healthhistoryarr = this.userInfo.healthHistory.split(",");
      var removeduplicate = Array.from(new Set(healthhistoryarr));
      console.log(removeduplicate);
      for (var i = 0; i < removeduplicate.length; i++) {
        if (removeduplicate[i] != "") {

          this.healthHistoryList.forEach(element => {
            if (removeduplicate[i] == element.itemName) {
              if (removeduplicate[i] == 'Other') {
                $('#otherhealthhistory').val(this.userInfo.other);
                $('#othertextfield').show();
              }
              this.selectedItems.push(element);
            }
          });
        }
      }
      console.log(this.selectedItems);
    }
    }
  }



  onItemSelect(item: any) {
    console.log(item);
    if (item.itemName == "Other") {
      $('#othertextfield').show();
    }

    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    if (item.itemName == 'Other') {
      $('#othertextfield').hide();
      $('#otherhealthhistory').val('');
      this.other="";
    }
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
 
    console.log(items);
    for(var i=0;i<items.length;i++){
      if (items[i].itemName =='Other') {
        $('#othertextfield').show();
      }
    }
  

  }
  onDeSelectAll(items: any) {
    console.log(items);
    if(items.length==0){
        $('#othertextfield').hide();
        $('#otherhealthhistory').val('');
        this.other="";
    }
  
  }
  printHelathCardForMobile(healthcard){
    window.open(healthcard, '_self');

// var DocumentContainer = document.getElementById("printForMobile");
//     var WindowObject = window.open('', 'PrintWindow', 'width=1310,height=650,top=0,left=0,toolbars=no,scrollbars=yes,status=no,resizable=yes');
//     WindowObject.print();

//     WindowObject.document.writeln(DocumentContainer.innerHTML);

//     WindowObject.document.close();
//     WindowObject.focus();
//     WindowObject.print();
//     WindowObject.close();
// window.print();

  }



  printHealthCardOnSinglePage() {

    let printContents, popupWin;
    printContents = document.getElementById('singlePage').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
       
          <style>
        
    /* Health Card css */
      .td{
        word-wrap:break-word; 
      }
      td.tdnormalfontwithleft{
      
        text-align: left;
        padding: 0px;
        font-family: 'Times New Roman';
      font-size:12px;
        }
        td.tdboldfontwithcenter{
          text-align: center;
        padding: 0px;
      font-family: 'Times New Roman';
        font-weight:bold;
      font-size:12px;
        }
        td.tdnormalfontwithcenter{
        text-align: center;
        padding: 0px;
      font-family: 'Times New Roman';
      font-size:12px;
      }


        .divsizehealthhistory{
         word-wrap:break-word; 
        width:320px;
        height:45px; 
        overflow: hidden !important;
      word-wrap:break-word; 
      }

      .divsizepolicydetails{
        width:320px;
        height:13px; 
        overflow: hidden !important;
      }
      .divsizereferaltext{
        height:11px; 
        overflow: hidden !important;
      }
      .divsizeaddress{
        width:320px;
      display: block; 
      height:28px; 
      overflow: hidden !important;
        }

      .divsizehealthcardbackside{
      width:320px;
      display: block; 
      height:71px; 
      overflow: hidden !important;
    }
    p.healthcardparagraph{
      margin-bottom: 0px;
    }

    .lefttable{
     width: 330px;
      height: 204px;
     border: 1px
      word-wrap:break-word; 
    }

    .maintable{
      table-layout: fixed;
      width: 660px;
      height: 204px;
    }

    table.bordertable{
     border: 1px solid black;
   }
   .qrcode{
    text-align: left;
   }
    p{margin:0; padding:0}
    td{margin:0; padding:0}

    .emergencyDetailsCenter{ 
      text-align:center; 
    
      padding: 0px;
      font-family: 'Times New Roman';
      font-size:12px;
    } 
    .watermarkhealthcardimage
   {
    width: 100px;
    height: 99px;
     background:url('../../../assets/images/watermark.png');
   background-repeat:no-repeat;
    background-position:center;
    }
  
    .watermarkhealthcard{
     width: 330px;
      height: 200px;
    // opacity:0.6;
    // filter:alpha(opacity=60);
     }
        @page {
          size:8.3in 11.7in;  
          margin: .0in .5in .5in 0.5in; 
          mso-header-margin: .5in; 
          mso-footer-margin: .5in; 
          mso-paper-source: 0;
     }
     
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  loadHealtCardBakSideForm(reponse, printStatus) {
    debugger;
    this.isHealthCardBackSideForm = true;
    var postaladdress = "";
    if (reponse.address != null) {

      if (reponse.postalAddress != null) {

        var addarr = reponse.postalAddress.split("-");
        var addarr1 = addarr[1].split(",");
        var addarr2 = addarr1[1].split("[");

        postaladdress = reponse.address + " " + addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
      } else {
        postaladdress = reponse.pinCode + ", India";
      }
    } else {

      if (reponse.postalAddress != null) {

        var addarr = reponse.postalAddress.split("-");
        var addarr1 = addarr[1].split(",");
        var addarr2 = addarr1[1].split("[");

        postaladdress = addarr1[0] + ", " + addarr1[1] + " " + addarr[0] + ", " + addarr2[0].substring(0, 1) + addarr2[0].substring(1, addarr2[0].length).toLowerCase() + ", India";
      } else {
        postaladdress = reponse.pinCode + ", India";
      }

    }


    var healthhistory = "";
    var other = "";

    if (reponse.healthHistory != null) {
      if (reponse.healthHistory !== "") {

        var historyarr = reponse.healthHistory.split(",");

        for (var i = 0; i < historyarr.length; i++) {
          if (historyarr[i] === "Other") {
            other = reponse.other;
          } else if (historyarr[i] === "") {

          } else {
            healthhistory = healthhistory + historyarr[i] + ", ";
          }
        }
      }
    }
    healthhistory = healthhistory + other;


    this.hcBackSideForm = this.formBuilder.group({
      'pageprint': [printStatus],
      'profileImgPath': [reponse.profileImgPath],
      'mdhlId': [reponse.emailAddress],
      'firstName': [reponse.firstName],
      'lastName': [reponse.lastName],
      'dob': [reponse.dob],
      'mobileNo': [reponse.mobileNumber],
      'gender': [reponse.gender],
      'bloodGroup': [reponse.bloodGroup],
      // 'pinCode': [reponse.pinCode],
      'address': [postaladdress],
      // 'postalAddress':[reponse.postalAddress],
      // 'otherHealthHistory': [reponse.other],
      'healthHistory': [healthhistory],
      'policyDetails': [reponse.policyDetails],
      'emergencyName': [reponse.emergencyName],
      'emergencyContactNo': [reponse.emergencyConatctNo],

      'scanqrcode': ['Scan QR Code'],
      'qrcodelogo': ['https://mdhl.s3.ap-south-1.amazonaws.com/mdhlQrCode.png'],
      'or': ['OR'],
      'visit': ['Visit app.mdhl.in'],
      'issuedby': ['Health Card issued by'],
      'poweredby': [' EasyReach Healthcare Private Limited'],
      'callus': ['Call Us:+918433513351 (Mon-Fri):10.00 AM-06.00 PM (IST)'],
      'hcRefferalText': [reponse.healthCardIssueText],
      'hcBackSideText': [reponse.healthCardBackSideText],

    })

    this.healthCardBackSidePreviewObj = this.hcBackSideForm.value;
    console.log(this.healthCardBackSidePreviewObj);

  }

  previewHealthCardBakSideClearData() {
    $("#previewORPrintHealthCardModal").modal("hide");
    this.healthCardBackSidePreviewObj = null;
  }




  //browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    console.log('Back button pressed');

    $("#shareHealthCardModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#previewHealthCardModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
   
  }
//browser back button or mobile back button

closePreviewHealthCard(){
  $("#previewORPrintHealthCardModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
}





}
